/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('PublicFilesCtrl', function(
    $scope,
    api_url,
    ErrorThrower,
    File,
    intraprof_api_url,
    identity
) {
    const errorManager   = new ErrorThrower;
    $scope.options = {
        upload: {
            enabled: Array.from(identity.groups).includes('adm') || Array.from(identity.groups).includes('intra_prof_adm'),
            base_url: `${intraprof_api_url}/students/files`
        },
        download: {
            enabled:  true,
            base_url: `${api_url}/students/download`
        },
        remove: {
            enabled:   Array.from(identity.groups).includes('adm') || Array.from(identity.groups).includes('intra_prof_adm'),
            base_url: `${intraprof_api_url}/students/files`
        },
        filter: {
            enabled: false,
            base_url: ''
        }
    };

    $scope.normalizeFile = function(file) {
        file.path = file.path.replace(/^[\/]*/, '');
        return file;
    };

    return File.query()
    .$promise
    .then(files => $scope.files = files).catch(error => errorManager.minor(error.statusText));
});
